import { Button, Group, Modal, Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import FieldSelect from '@/components/shared/form/FieldSelect';
import FieldText from '@/components/shared/form/FieldText';
import FieldTextareaWithEditingMode from '@/components/shared/form/FieldTextareaWithEditingMode';
import Loader from '@/components/ui/Loader';
import MobileBottomDrawer from '@/components/ui/MobileBottomDrawer';
import { InsightQuickCaptureStore } from '@/stores/local/shared/quickThoughts';
import { useDevices } from '@/utils/devices';

import s from './InsightQuickCaptureModal.module.scss';

type InsightQuickCaptureModalProps = {
  store: InsightQuickCaptureStore;
};

const InsightQuickCaptureModal: React.FC<InsightQuickCaptureModalProps> = ({ store: insight }) => {
  const { isCompactViewport } = useDevices();

  React.useEffect(() => {
    insight.form.fieldsMap.topic.load(true);
  }, [insight.form.fieldsMap.topic]);

  const buttonMobileText = insight.entity === null ? 'Создать инсайт' : 'Сохранить инсайт';

  const formFields = (
    <>
      <FieldText store={insight.form.fieldsMap.title} placeholder="Название инсайта" />
      <FieldSelect
        store={insight.form.fieldsMap.topic}
        placeholder="Выберите тему"
        label="Тема"
        withSearch
        withCloseButton
        size="sm"
      />
      <FieldSelect
        store={insight.form.fieldsMap.lifespan}
        placeholder="Выберите срок жизни"
        label="Срок жизни"
        withCloseButton
        size="sm"
      />
      <FieldTextareaWithEditingMode
        store={insight.form.fieldsMap.text}
        placeholder="Добавьте текст инсайта"
        minRows={8}
        autosize
      />
    </>
  );

  if (isCompactViewport) {
    return (
      <MobileBottomDrawer
        opened={insight.isOpen}
        onClose={insight.close}
        title="Новый инсайт"
        contentClassName={s.root__drawer}
        footerClassName={s['root__footer-drawer']}
        actions={
          <Button onClick={insight.submit} loading={insight.meta.isLoading} disabled={!insight.canSubmit}>
            {buttonMobileText}
          </Button>
        }
      >
        {insight.isLoading ? (
          <Loader type="dots" fullHeight />
        ) : (
          <div className={s.root__scroll}>
            <Stack gap="md">{formFields}</Stack>
          </div>
        )}
      </MobileBottomDrawer>
    );
  }

  return (
    <Modal
      classNames={{ body: s.root }}
      opened={insight.isOpen}
      onClose={insight.close}
      title="Новый инсайт"
      size="lg"
      centered
      trapFocus={false}
    >
      {insight.isLoading ? (
        <Loader type="dots" fullHeight />
      ) : (
        <Stack gap="md">
          {formFields}
          <Group justify="flex-end">
            <Button onClick={insight.submit} loading={insight.meta.isLoading} disabled={!insight.canSubmit}>
              Сохранить
            </Button>
          </Group>
        </Stack>
      )}
    </Modal>
  );
};

export default observer(InsightQuickCaptureModal);
